import { createAction } from "@reduxjs/toolkit";

export const resetOrganisationAction = createAction("organisation/reset");
